import { Toast } from '@skbkontur/react-ui';
import { checkHostConnection } from './checkHostConnection';
export const showUnknownError = async (message) => {
    if (!(await checkHostConnection())) {
        Toast.push('Нет соединения с интернетом');
        return;
    }
    Toast.push(message || 'Что-то пошло не так. Если ошибка повторяется, напишите в поддержку');
};
